import { getValidateSiteLang } from '../services/general.services';
import { isLocalEnvironment } from './generalServices.util';
function getCookieValue(name:string) {
  const cookies = document.cookie.split('; ');
  const cookie = cookies.find(c => c.startsWith(`${name}=`));
  return cookie ? cookie.split('=')[1] : null;
}

// Example usage


export const getLangSite = (langDefault: string) => {
    const hostName = window.location.hostname;
    const pathName = window.location.pathname;
    const myCookie: string | null = getCookieValue('Currency');

    let langSite = { site: '', lang: '',curr:myCookie };
    
    if (isLocalEnvironment()) {
        langSite = { site: 'za', lang: 'en',curr:myCookie??'ZAR'};
    } else {
        const searchStr = '.digikey.';
        const site = hostName
            .substring(hostName.indexOf(searchStr) + searchStr.length)
            .split('.');

        const langTemp = pathName.split('/')[1];
        let lang = '';

        if (langTemp.length !== 2) lang = 'en';
        else lang = langTemp;

        // ! if has sub domain
        if (langDefault) {
            if (site.length > 1) {
                langSite.site =
                    site[1] === 'com' || site[1] === 'uk' ? langDefault : site[1];
            } else {
                langSite.site =
                    site[0] === 'com' || site[0] === 'uk' ? langDefault : site[0];
            }
        }
        

        langSite.lang = lang;
        
    }

    return langSite;
};

const replaceUrl = (
    replaceLangCode: string,
) => {
    const tempArray = window.location.href.split('/');
    tempArray[3] = replaceLangCode;
    return tempArray.join('/');
}

export const actionAfterValidateSiteLang = (
    isValid: boolean,
    defaultLang: string
) => {
    if (!isValid) {
        const replacedUrl = replaceUrl(defaultLang);
        window.location.replace(replacedUrl);
    }
}

export const validateSiteLang = async () => {
    const siteLangValidateResponse = await getValidateSiteLang();
    actionAfterValidateSiteLang(siteLangValidateResponse.isValidSiteLang, siteLangValidateResponse.defaultLangCode);
}  